export default "/images/347848d32b30b07875e1c92bd03bda41.avif";